import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { appRoutes } from "./app/app.routes";
import { AppComponent } from "./app/app.component";
import { registerLocaleData } from "@angular/common";
import { provideHbI18n } from "./app/felles/providers/i18n.provider";
import localeFrNb from "@angular/common/locales/nb";

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeFrNb);

bootstrapApplication(AppComponent, {
  providers: [
    provideHbI18n(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      }),
    ),
  ],
}).catch(error => console.error("Failed to initialize the application", error));
